import { useContext } from 'react';

import PageHeader from '@/components/PageHeader';
import PersonMedicationsList from '@/components/PersonMedicationsList/PersonMedicationsList';
import useMedications from '@/hooks/useMedications';
import PersonContext from '@/pages/Person/PersonContext';
import Alert from '@/ui/components/Alert';
import Container from '@/ui/components/Container';
import LoadingSkeleton from '@/ui/components/LoadingSkeleton';

const PersonMedications = () => {
  const { person } = useContext(PersonContext);

  const {
    data: medications,
    isError,
    error,
    isPending
  } = useMedications({
    person_id: person.id,
    show_inactive: 'false'
  });

  return (
    <Container type="page">
      <PageHeader headingText="Medications" className="sr-only" />

      {isPending ? (
        <LoadingSkeleton />
      ) : isError ? (
        <Alert level="error">{error.toString()}</Alert>
      ) : medications?.data?.length ? (
        <PersonMedicationsList medications={medications.data} />
      ) : (
        <div>No medications found.</div>
      )}
    </Container>
  );
};

export default PersonMedications;
